import React from "react";
import { useNavigate } from "react-router-dom";
import { Box, Paper, Typography, Button } from "@mui/material";
import { styled } from "@mui/material/styles";
import { Home } from "lucide-react";
import SadPizzaImage from "../media/sad-pizza.png";

const Container = styled(Paper)(({ theme }) => ({
  width: "100%",
  margin: "0 auto",
  boxShadow: theme.shadows[6],
  display: "flex",
  flexDirection: "column",
  minHeight: "100vh",
  backgroundColor: "#fff",
}));

const Content = styled(Box)(({ theme }) => ({
  flex: 1,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "flex-start",
  padding: theme.spacing(4),
  paddingTop: theme.spacing(10),
  textAlign: "center",
}));

const PizzaImage = styled("img")(() => ({
  width: 200,
  height: 200,
  objectFit: "contain",
  marginBottom: 24,
  animation: "float 3s ease-in-out infinite",
  "@keyframes float": {
    "0%, 100%": {
      transform: "translateY(0px)",
    },
    "50%": {
      transform: "translateY(-10px)",
    },
  },
}));

const ErrorCode = styled(Typography)(({ theme }) => ({
  fontSize: "6rem",
  fontWeight: 700,
  background: "linear-gradient(90deg, #f97316, #ef4444)",
  WebkitBackgroundClip: "text",
  WebkitTextFillColor: "transparent",
  backgroundClip: "text",
  lineHeight: 1,
  marginBottom: theme.spacing(2),
}));

const ErrorTitle = styled(Typography)(({ theme }) => ({
  fontWeight: 700,
  color: theme.palette.grey[800],
  marginBottom: theme.spacing(1),
}));

const ErrorMessage = styled(Typography)(({ theme }) => ({
  color: theme.palette.grey[600],
  marginBottom: theme.spacing(4),
  maxWidth: 400,
}));

const HomeButton = styled(Button)(({ theme }) => ({
  paddingInline: theme.spacing(3),
  paddingBlock: theme.spacing(1.5),
  borderRadius: theme.spacing(2),
  fontWeight: 700,
  textTransform: "none",
  background: "linear-gradient(90deg, #f97316, #ef4444)",
  color: "#fff",
  boxShadow: theme.shadows[4],
  "&:hover": {
    background: "linear-gradient(90deg, #fb923c, #f97373)",
    boxShadow: theme.shadows[8],
  },
}));

const NotFound = () => {
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate("/");
  };

  return (
    <Container elevation={0}>
      <Content>
        <PizzaImage src={SadPizzaImage} alt="Sad Pizza" />
        <ErrorCode>404</ErrorCode>
        <ErrorTitle variant="h5">Oops! This Page Doesn't Exist</ErrorTitle>
        <ErrorMessage variant="body1">
          Looks like you've wandered into uncharted territory. This page is as
          missing as pineapple on a pizza debate!
        </ErrorMessage>
        <HomeButton
          variant="contained"
          startIcon={<Home size={20} />}
          onClick={handleGoHome}
        >
          Take Me Home
        </HomeButton>
      </Content>
    </Container>
  );
};

export default NotFound;
